"use strict";
/* HELPERS */
Object.defineProperty(exports, "__esModule", { value: true });
const { getPrototypeOf, prototype } = Object;
/* IS PLAIN OBJECT */
const isPlainObject = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const proto = getPrototypeOf(value);
    return proto === null || proto === prototype;
};
/* EXPORT */
exports.default = isPlainObject;
